import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Icon from "../Icon";
import { getOtherProperties } from "../common/Utils";
import Ripple from "../Ripple";
import { RateProps } from "./PropsType";

export default function Rate(props: RateProps) {
  const {
    className,
    template,
    allowHalf = false,
    count = 5,
    defaultValue = 0,
    readOnly = false,
    disableRipple = true,
    prefixCls = "bm-Rate",
    ...other
  } = props;
  const styleClass = classNames(prefixCls, className);
  const [value, setValue] = useState(
    !!props.defaultValue && props.defaultValue > 0 ? props.defaultValue : 0
  );
  const otherProps = getOtherProperties(other, [
    "defaultValue",
    "value",
    "readOnly",
    "onChange",
  ]);
  const component = template ? template : <Icon icon="star" />;

  const getRange = (len: number, start: number = 0, step: number = 1) => {
    const range: any = [];
    for (let i = start; i < len; i += step) {
      range.push(i);
    }
    return range;
  };

  const isIn = (v: number) => {
    const ex = value - v;
    return ex > 0 && ex < 1;
  };

  const handleClick = (value: number, half: boolean, event: any) => {
    event.stopPropagation();
    const { allowHalf, onChange, readOnly }: any = props;
    let _value: any = 0;
    if (!readOnly) {
      _value = value + 1;
      if (half && allowHalf) {
        _value -= 0.5;
      }
      setValue(_value);
      if (onChange) {
        onChange(_value);
      }
    }
  };

  const children = (v: number, i: number) => {
    const isActive = v < value;
    const halfClass = classNames(
      {
        [`${prefixCls}-active`]: isActive,
      },
      `${prefixCls}-half`
    );
    const styles = {
      opacity: isIn(v) ? 1 : 0,
    };
    const iconClass = classNames({
      [`${prefixCls}-active`]: allowHalf ? !isIn(v) && isActive : isActive,
    });
    return (
      <div key={i} className={`${prefixCls}-item`}>
        {allowHalf ? (
          <div
            className={halfClass}
            style={styles}
            onClick={handleClick.bind(this, i, true)}
          >
            {component}
          </div>
        ) : null}
        <div className={iconClass} onClick={handleClick.bind(this, i, false)}>
          {component}
          {!disableRipple ? <Ripple centerMode={true} hidden={false} /> : null}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (typeof props.value === "number") {
      setValue(!!props.value && props.value > 0 ? props.value : 0);
    }
  }, [props.value]);

  return (
    <div className={styleClass} {...otherProps}>
      {getRange(count!).map((v: any, i: number) => {
        return children(v, i);
      })}
    </div>
  );
}
